import React from 'react';
import { 
    FiFileText,     // ۱. تایید فاکتور
    FiPackage,      // ۲. آماده‌سازی و بسته‌بندی
    FiTruck,        // ۳. ارسال به پست
    FiSend,         // ۴. تحویل به پست
    FiMail,
    FiCheckCircle,  // ۵. سفارشات تکمیل شده
    FiCheck,        // تیک سبز (تکمیل)
    FiX             // ضربدر قرمز (ابطال)
} from 'react-icons/fi';
import { ORDER_STEPS } from '../utils';
import './OrderStepper.css';

// نگاشت آیکون‌ها بر اساس شناسه مراحل
const STEP_ICONS = {
    1: FiFileText,
    2: FiPackage,
    3: FiTruck,
    4: FiSend,
    5: FiMail,
    6: FiCheckCircle,
};

export const OrderStepper = ({ currentStep = 2, isError = false, isDelivered = false }) => {
    const totalSteps = ORDER_STEPS ? ORDER_STEPS.length : 0;
    
    // پیدا کردن اندیس مرحله فعلی بر اساس id مرحله در آرایه ORDER_STEPS
    const currentStepIndex = ORDER_STEPS 
        ? ORDER_STEPS.findIndex(s => Number(s.id) === Number(currentStep)) 
        : -1;
    const activeIndex = currentStepIndex !== -1 ? currentStepIndex : 0;

    // بررسی آخرین مرحله
    const lastStep = ORDER_STEPS && totalSteps > 0 ? ORDER_STEPS[totalSteps - 1] : null;
    const isAtLastStep = lastStep && Number(lastStep.id) === Number(currentStep);

    // تکمیل نهایی
    const isFullyCompleted = isDelivered || isAtLastStep;

    // درصد پیشرفت خط اتصال
    let progressPercent = 0;
    if (isError || isFullyCompleted) {
        progressPercent = 100;
    } else if (totalSteps > 1) {
        progressPercent = (activeIndex / (totalSteps - 1)) * 100;
    }

    return (
        <div 
            className={`stepper-container ${isError ? 'error-mode' : ''}`}
            style={{ '--steps-count': totalSteps }}
        >
            {/* خط اتصال و پیشرفت */}
            <div className="stepper-line">
                <div 
                    className="stepper-line-fill" 
                    style={{ width: `${progressPercent}%` }}
                />
            </div>

            {ORDER_STEPS && ORDER_STEPS.map((step, index) => {
                const StepIcon = STEP_ICONS[step.id] || step.icon || FiPackage;

                // ۱. وضعیت ابطال شده
                if (isError) {
                    const isRejectedStep = index === activeIndex;
                    return (
                        <div key={step.id} className="step-item cancelled">
                            <div className="step-circle">
                                <StepIcon className="step-icon" />
                                {isRejectedStep && (
                                    <span className="step-badge error-badge">
                                        <FiX />
                                    </span>
                                )}
                            </div>
                            <span className="step-text">{step.title}</span>
                        </div>
                    );
                }

                // ۲. وضعیت تحویل داده شده / تکمیل نهایی
                if (isFullyCompleted) {
                    return (
                        <div key={step.id} className="step-item completed">
                            <div className="step-circle">
                                <StepIcon className="step-icon" />
                                <span className="step-badge check-badge">
                                    <FiCheck />
                                </span>
                            </div>
                            <span className="step-text">{step.title}</span>
                        </div>
                    );
                }

                // ۳. وضعیت عادی و در حال پردازش
                const isCompleted = index < activeIndex;
                const isCurrent = index === activeIndex;

                let itemClass = 'pending';
                if (isCompleted) itemClass = 'completed';
                else if (isCurrent) itemClass = 'current';

                return (
                    <div key={step.id} className={`step-item ${itemClass}`}>
                        <div className="step-circle">
                            <StepIcon className="step-icon" />
                            {isCompleted && (
                                <span className="step-badge check-badge">
                                    <FiCheck />
                                </span>
                            )}
                        </div>
                        <span className="step-text">{step.title}</span>
                    </div>
                );
            })}
        </div>
    );
};
